import { Card, NavList, Box, MessageBlock } from '@deckee/deck-hand';
import React, { MouseEvent } from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { captureEvent } from '../../../../services/event-capture';
import { openWithInAppBrowser } from '../../../../services/in-app-browser';
import { usePartner } from '../../../../services/store/modules/partners/hooks/usePartner';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import { LayoutBody } from '../../../layouts/components/LayoutBody/LayoutBody';
import LogoSpinner from '../../../shared/_deprecated/components/LogoSpinner/LogoSpinner';

const StyledLinkIcon = styled.img`
  max-height: 50px;
`;

const PartnerHubPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const { partner, loading } = usePartner(slug);

  const errorLoading = !loading && !partner;

  const handleClickLink = (e: MouseEvent, link: string) => {
    e.preventDefault();
    e.stopPropagation();

    captureEvent({
      type: 'partner hub: click link',
      payload: {
        partnerId: partner?.id,
        url: link,
      },
    });

    openWithInAppBrowser({ url: link });
  };

  const mainImage = partner?.primaryImage || partner?.icon;

  return (
    <BasicDrawerLayout
      heading="Partner"
      backgroundImage={partner?.backgroundImage || undefined}
    >
      <LayoutBody>
        {errorLoading && (
          <MessageBlock type="warning">
            Unable to load this partner.{' '}
            <Link to="/maps/prepare">
              View the list of partners and resources available in your map area
            </Link>
          </MessageBlock>
        )}

        {loading && <LogoSpinner />}

        {partner && (
          <>
            <Card pt="0">
              <Card.Heading
                display="flex"
                alignItems="center"
                justifyContent="center"
                m="0 !important"
                p="0 !important"
              >
                <Box p="4">
                  {mainImage ? (
                    <Box
                      as="img"
                      maxWidth="100%"
                      height="auto"
                      width="auto"
                      src={mainImage}
                      alt=""
                    />
                  ) : (
                    partner?.name
                  )}
                </Box>
              </Card.Heading>
            </Card>
            <Card.Body px="0" pt="0">
              <NavList>
                {partner?.links?.map((link) => (
                  <NavList.Item
                    key={link?.id}
                    onClick={(e: MouseEvent) => handleClickLink(e, link.url)}
                    chevron
                  >
                    {link?.icon && <StyledLinkIcon src={link?.icon} alt="" />}
                    <Box>{link.name}</Box>
                  </NavList.Item>
                ))}
              </NavList>
            </Card.Body>
          </>
        )}
      </LayoutBody>
    </BasicDrawerLayout>
  );
};

export default PartnerHubPage;
